var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('exec-placeholder',{attrs:{"title":"WhatsApp — atención y conversión","message":"Este canal se habilitará cuando el flag whatsapp.channel esté activo. La atención y conversión de la app propia se reporta en el endpoint app-conversion."}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }